import { createChildListViewContainer } from 'factories/ChildListView'
import actions from 'actions/assets/assetTolerances'
import Component from 'components/Assets/Tolerances'

export default createChildListViewContainer({ actions })(Component)
